import {FormSectionHeading} from '@sollapay/ui/components';
import {Controller} from 'react-hook-form';
import {useTranslation} from 'react-i18next';

import {SellerTypeToggle} from './SellerTypeToggle';

import type {SellerType} from '@sollapay/enums';
import type {ComponentProps} from 'react';
import type {Control, FieldPath, FieldValues} from 'react-hook-form';

export interface SellerTypeSectionProps<TFieldValues extends FieldValues> {
  control: Control<TFieldValues>;
  sellerTypeName: FieldPath<TFieldValues>;
  titleSize?: ComponentProps<typeof FormSectionHeading>['titleSize'];
}

/** The entity question alone — every deal type but an option assignment, whose roster holds two sides. */
export function SellerTypeSection<TFieldValues extends FieldValues>({
  control,
  sellerTypeName,
  titleSize
}: SellerTypeSectionProps<TFieldValues>) {
  const {t} = useTranslation('trustAccounts');

  return (
    <Controller
      name={sellerTypeName}
      control={control}
      render={({field}) => (
        <div className="flex flex-col gap-4">
          <FormSectionHeading
            titleSize={titleSize}
            title={t('activation.packages.trustDetails.form.fields.sellerType')}
            description={t('activation.packages.trustDetails.form.fields.sellerTypeDescription')}
          />
          <SellerTypeToggle value={field.value as SellerType} onChange={field.onChange} />
        </div>
      )}
    />
  );
}
